import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';

import { SETTINGS_MEMBER_LIST_QUERY } from '../../graphql';

@Injectable({ providedIn: 'root' })
export class SettingsMembersListService {
  private clientName = APOLLO_CLIENT_NAMES.contact;

  constructor(private readonly apollo: Apollo) {}

  getSettingsMembersList(accountDnvId: string | null): Observable<any> {
    const fieldName =
      getQueryRootFieldName(SETTINGS_MEMBER_LIST_QUERY) || 'memberList';

    return this.apollo
      .use(this.clientName)
      .query({
        query: SETTINGS_MEMBER_LIST_QUERY,
        variables: {
          accountDNVId: accountDnvId,
        },
        fetchPolicy: 'no-cache',
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((results: any) => results?.data?.memberList),
      );
  }
}
